<template>
  <a
    class="te-fixed-button fixed inset-x-0 bottom-0 z-50 mx-auto w-[15.4rem] rounded-t bg-[rgba(51,51,51,0.6)] py-2 text-center text-white hover:bg-[rgba(51,51,51,0.7)] hover:text-white md:w-[18.3125rem]"
    href="#schedule"
    @click.prevent="scrollTo('schedule')"
  >
    <span class="co-display-12">当日1時間後から予約可</span>
    <br>
    無料相談を受けてみる
    <FontAwesomeIcon
      :icon="faChevronDown"
      class="mx-auto block h-4 w-5"
    />
  </a>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// ScrollTrigger
const fixedButton = () => {
  ScrollTrigger.create({
    trigger: '#target', // ページに存在しないidを指定することで上方向のスクール時に要素が非表示にならないようにしています
    start: 'top center',
    toggleActions: 'none none none none',
    endTrigger: '#schedule',
    end: 'top +=100%',
    toggleClass: {
      targets: '.te-fixed-button',
      className: 'active',
    },
    // markers: true,
  })
}

onMounted(() => {
  if (import.meta.client) {
    gsap.registerPlugin(ScrollTrigger);
  }

  fixedButton()
})
</script>

<style scoped>
.te-fixed-button {
  display: none;
  animation-duration: 0.5s;
  &.active {
    display: block;
    animation-name: fade-in;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
